<template>
    <ns-modal
        v-model="dialog"
        :fullscreen="fullScreen"
        :title="txc.edit_mobile_number"
        @input="closeDialog"
    >
        <server-error v-if="!!dialogError" :error="dialogError" />
        <v-form ref="mobilePhoneForm" v-model="form" @submit.prevent>
            <section>
                <div class="field-label">{{txc.current_mobile}}</div>
                <div class="field-value">{{mobileFormatted}}</div>
            </section>
            <div id="phoneNumber" class="edit-phone-number">
                <ns-phone-number

                    :country="country"
                    :errorMessage="sharedStrings.forms.fieldRequired"
                    :invalidMessage="sharedStrings.forms.invalidPhoneNumber"
                    :label="txc.new_mobile_number"

                    v-model="mobilePhoneNumber"
                    @input="validate"
                    @update:error="processError"
                />
            </div>
        </v-form>
        <template v-slot:actions>
            <v-layout column>
                <v-flex xs12>
                    <button
                        type="button"
                        ref="phoneSave"
                        flat
                        block
                        :disabled="!phoneValid"
                        class="primary-hit mb-2 fluid"
                        @click="updatePhone"
                    >{{sharedStrings.generic.save}}</button>
                </v-flex>
                <v-spacer/>
                <v-flex xs12>
                    <button flat block class="secondary-hit fluid" @click="closeDialog">{{sharedStrings.generic.cancel}}</button>
                </v-flex>
            </v-layout>
        </template>
    </ns-modal>
</template>

<script>
import { ProfileService } from '@nuskin/ns-account';
import { mapGetters, mapActions } from 'vuex';
import { NsModal, NsPhoneNumber, NsPhoneNumberFormats } from '@nuskin/design-components';
import ServerError from '../ServerError';
import * as ruleSet from '../../repositories/globalRules.js';
import profileUtils from '../../repositories/profileUtils';


const lenRule = v =>
    v.length >= NsPhoneNumberFormats[profileUtils.getCountry()].minLength || '';

export default {
    components: {
        NsModal,
        ServerError,
        NsPhoneNumber
    },
    data() {
        return {
            ruleSet,
            dialog: true,
            dialogError: null,
            mobilePhoneNumber: { country: profileUtils.getCountry(), number: '' },
            country: profileUtils.getCountry(),
            phonePrefix:
            NsPhoneNumberFormats[profileUtils.getCountry()].countryPhoneCode,
            phoneMask: NsPhoneNumberFormats[profileUtils.getCountry()].mask,
            hint: NsPhoneNumberFormats[profileUtils.getCountry()].placeholder,
            form: {},
            minLenRule: lenRule,
            phoneValid: null
        };
    },
    computed: {
        ...mapGetters({
            txc: 'translationsCommunication',
            mobileNumber: 'mobileNumber',
            mobileFormatted: 'mobileFormatted',
            fullScreen: 'mobileView',
            account: 'account',
            phoneCountries: 'phoneCountries',
            sharedStrings: 'sharedStrings'
        })
    },
    methods: {
        ...mapActions(['setAccount']),
        closeDialog() {
            this.$emit('closeDialog');
            this.dialogError = null;
        },
        validate(e) {
        },
        // The event for this passes a bool for invalid phone number
        // False is valid phone number.
        processError(e) {
            if (e) {
                this.phoneValid = false;
            }
            else {
                this.phoneValid = true;
            }
        },
        updatePhone() {
            let self = this;
            let updatedMobilePhoneNumber = {
                phoneNumbers: {
                    mobile: {
                        country: self.mobilePhoneNumber.country,
                        value: self.mobilePhoneNumber.number
                    }
                }
            };
            ProfileService.updateAccountInfo(updatedMobilePhoneNumber)
                .then(function(response) {
                    if (response && response.data && response.data.account) {
                        self.setAccount(response.data.account);
                        self.closeDialog();
                        profileUtils.publishAnalytics(
                            self.$analytics.category.communications,
                            'mobile_number',
                            'updated',
                            { email: self.account.email }
                        );
                    }
                })
                .catch(error => {
                    self.dialogError = error;
                });
        }
    },
    created() {
        profileUtils.publishAnalytics(
            this.$analytics.category.communications,
            'mobile_number_dialog',
            'opened'
        );
    },
    destroyed() {
        profileUtils.publishAnalytics(
            this.$analytics.category.communications,
            'mobile_number_dialog',
            'closed'
        );
    }
};
</script>

<style  lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/vuetifyOverrides";
    ::v-deep {
  
        .v-input__append-inner {
          position: relative !important;
          top: 5px !important;
        }
    }
</style>
<style lang="scss" >
.phone-number .phone-dropdown {
  max-width: 130px;
  .selected-code {
    z-index: 800;
    white-space: nowrap;
  }
}
.container #phoneNumber.edit-phone-number .v-select .v-input__control .v-input__slot {
  border: 1px solid #bbbcbc;
    .v-select__slot {
      flex-flow: row nowrap !important;
        input {
          border: none;
        }
    }
}
</style>